var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.CountLoading) ? _c('div', {
    staticClass: "loader-overlay d-flex flex-column align-items-center justify-content-center"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('b-progress', {
    attrs: {
      "value": _vm.progressCount,
      "max": "100",
      "height": "20px",
      "animated": "",
      "striped": "",
      "variant": "success"
    }
  }), _vm._v(" "), _vm._m(0)], 1)]) : _vm._e(), _vm._v(" "), (_vm.ActiveTabIndex == 0) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "new-allocation-panel"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-sm-8 mt-1"
  }, [_vm._v(" Allocation Panel ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end gap-2"
  }, [_c('span', [_c('button', {
    staticClass: "btn btn-sm btn-light mr-2 pending"
  }, [_vm._v("\n                          Pending :"), _c('strong', [_vm._v(" " + _vm._s(_vm.airshipmentscount) + " ")]), _vm._v(" "), _c('small', {
    staticClass: "label-bottom"
  }, [_vm._v("Air ")]), _vm._v("  |  "), _c('strong', [_vm._v(_vm._s(_vm.WHIZshipmentcount) + " ")]), _c('small', {
    staticClass: "label-bottom"
  }, [_vm._v("AirWiz")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redirectToExternalPortals('b2bPortal')
      }
    }
  }, [_vm._v("\n                            B2B Pending (" + _vm._s(_vm.b2bPendingCount) + ")  "), _c('i', {
    staticClass: "fa fa-share-square-o IconSize"
  })]), _vm._v("  \n                        "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redirectToExternalPortals('priorityReport')
      }
    }
  }, [_vm._v("\n                            Allocation Performance  "), _c('i', {
    staticClass: "fa fa-share-square-o IconSize"
  })])])])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "tabs-active"
  }, [_c('b-tabs', {
    staticClass: "NewAllocationtab",
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "FWD"
    }
  }, [(_vm.IsDelivery) ? _c('div', [(_vm.ActiveTabIndex == 0) ? _c('forward-allocation', {
    attrs: {
      "srList": _vm.srList,
      "hyperVMsgData": _vm.hyperVMsgData,
      "hubCODPendingLimit": _vm.hubCODPendingLimit,
      "IsPendingCODBlock": _vm.IsPendingCODBlock,
      "isRSVSr": _vm.isRSVSr,
      "ServiceTypeArrayList": _vm.ServiceTypeArrayList,
      "ServiceTypeList": _vm.ServiceTypeList,
      "EscalationList": _vm.EscalationList,
      "ClusterList": _vm.ClusterList,
      "allocationrefreshflag": _vm.allocationrefreshflag,
      "isSVCEnabledForAdhocVehicles": _vm.isSVCEnabledForAdhocVehicles,
      "isScannerOnlyAllocationEnabled": _vm.isScannerOnlyAllocationEnabled
    },
    on: {
      "update-air-count": _vm.getAirShipmentCount,
      "update-airwiz-count": _vm.getWHIZshipmentcount
    }
  }) : _vm._e()], 1) : _c('div', [_c('span', [_vm._v("Allocation Panel is not available for this HUB,Kindly reach out to Tech Support")])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "RVP"
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs('RVP')
      }
    }
  }, [(_vm.IsRVP) ? _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.rvpUserLoading
    },
    on: {
      "update:active": function($event) {
        _vm.rvpUserLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.ActiveTabIndex == 1 && _vm.srList.length > 0) ? _c('Reverse-allocationv2', {
    attrs: {
      "srList": _vm.srList,
      "hyperVMsgData": _vm.hyperVMsgData,
      "hubCODPendingLimit": _vm.hubCODPendingLimit,
      "IsPendingCODBlock": _vm.IsPendingCODBlock,
      "isRSVSr": _vm.isRSVSr,
      "ServiceTypeArrayList": _vm.ServiceTypeArrayList,
      "ServiceTypeList": _vm.ServiceTypeList,
      "EscalationList": _vm.EscalationList,
      "ClusterList": _vm.ClusterList,
      "allocationrefreshflag": _vm.allocationrefreshflag,
      "isSVCEnabledForAdhocVehicles": _vm.isSVCEnabledForAdhocVehicles
    }
  }, [_vm._v(_vm._s(_vm.ActiveTabIndex))]) : _vm._e()], 1) : _c('div', [_c('span', [_vm._v("Allocation Panel is not available for this HUB,Kindly reach out to Tech Support")])])])], 1)], 1)])], 1)]) : _c('div', {
    staticClass: "row",
    attrs: {
      "id": "new-allocation-panel"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show('first')),
      expression: "show('first')"
    }],
    class: ['p-3 text-white', _vm.firstClass]
  }, [_c('legend', {
    staticClass: "w-100 d-flex justify-content-between align-items-center"
  }, [_vm._v("\n                Allocation Panel\n                "), _c('div', [(_vm.layout === 'half') ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.expand('first')
      }
    }
  }, [_vm._v("\n                        +\n                    ")]) : (_vm.layout === 'first') ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.collapse()
      }
    }
  }, [_vm._v("\n                        −\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "tabs-active"
  }, [_c('b-tabs', {
    staticClass: "NewAllocationtab",
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "FWD"
    }
  }, [(_vm.IsDelivery) ? _c('div', [(_vm.ActiveTabIndex == 0) ? _c('forward-allocation', {
    attrs: {
      "srList": _vm.srList,
      "hyperVMsgData": _vm.hyperVMsgData,
      "hubCODPendingLimit": _vm.hubCODPendingLimit,
      "IsPendingCODBlock": _vm.IsPendingCODBlock,
      "isRSVSr": _vm.isRSVSr,
      "ServiceTypeArrayList": _vm.ServiceTypeArrayList,
      "ServiceTypeList": _vm.ServiceTypeList,
      "EscalationList": _vm.EscalationList,
      "ClusterList": _vm.ClusterList,
      "allocationrefreshflag": _vm.allocationrefreshflag,
      "isSVCEnabledForAdhocVehicles": _vm.isSVCEnabledForAdhocVehicles,
      "isScannerOnlyAllocationEnabled": _vm.isScannerOnlyAllocationEnabled
    },
    on: {
      "update-air-count": _vm.getAirShipmentCount,
      "update-airwiz-count": _vm.getWHIZshipmentcount
    }
  }) : _vm._e()], 1) : _c('div', [_c('span', [_vm._v("Allocation Panel is not available for this HUB,Kindly reach out to Tech Support")])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "RVP"
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs('RVP')
      }
    }
  }, [(_vm.IsRVP) ? _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.rvpUserLoading
    },
    on: {
      "update:active": function($event) {
        _vm.rvpUserLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.ActiveTabIndex == 1 && _vm.srList.length > 0) ? _c('Reverse-allocationv2', {
    attrs: {
      "srList": _vm.srList,
      "hyperVMsgData": _vm.hyperVMsgData,
      "hubCODPendingLimit": _vm.hubCODPendingLimit,
      "IsPendingCODBlock": _vm.IsPendingCODBlock,
      "isRSVSr": _vm.isRSVSr,
      "ServiceTypeArrayList": _vm.ServiceTypeArrayList,
      "ServiceTypeList": _vm.ServiceTypeList,
      "EscalationList": _vm.EscalationList,
      "ClusterList": _vm.ClusterList,
      "allocationrefreshflag": _vm.allocationrefreshflag,
      "isSVCEnabledForAdhocVehicles": _vm.isSVCEnabledForAdhocVehicles
    },
    on: {
      "start-loading": _vm.startLoading,
      "stop-loading": _vm.stopLoading
    }
  }, [_vm._v(_vm._s(_vm.ActiveTabIndex))]) : _vm._e()], 1) : _c('div', [_c('span', [_vm._v("Allocation Panel is not available for this HUB,Kindly reach out to Tech Support")])])])], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show('second') || _vm.ActiveTabIndex == 1),
      expression: "show('second') || ActiveTabIndex == 1"
    }],
    class: ['p-3 text-white', _vm.secondClass]
  }, [_c('legend', {
    staticClass: "w-100 d-flex justify-content-between align-items-center"
  }, [_vm._v("\n                Confirm Allocation\n                "), _c('div', [(_vm.layout === 'half') ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.expand('second')
      }
    }
  }, [_vm._v("\n                        +\n                    ")]) : (_vm.layout === 'second') ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.collapse()
      }
    }
  }, [_vm._v("\n                        −\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "tabs-active"
  }, [_c('b-tabs', {
    staticClass: "NewAllocationtab tabsborder",
    attrs: {
      "content-class": "mt-3"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Confirm allocation to SR"
    }
  }, [_c('div', {
    staticClass: "tabs-active"
  }, [_c('b-tabs', {
    staticClass: "NewAllocationtab tabsborder",
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "FWD"
    }
  }, [(_vm.IsDelivery) ? _c('div', [(_vm.ActiveTabIndex == 0) ? _c('forward-allocation', {
    attrs: {
      "srList": _vm.srList,
      "hyperVMsgData": _vm.hyperVMsgData,
      "hubCODPendingLimit": _vm.hubCODPendingLimit,
      "IsPendingCODBlock": _vm.IsPendingCODBlock,
      "isRSVSr": _vm.isRSVSr,
      "ServiceTypeArrayList": _vm.ServiceTypeArrayList,
      "ServiceTypeList": _vm.ServiceTypeList,
      "EscalationList": _vm.EscalationList,
      "ClusterList": _vm.ClusterList,
      "allocationrefreshflag": _vm.allocationrefreshflag,
      "isSVCEnabledForAdhocVehicles": _vm.isSVCEnabledForAdhocVehicles,
      "isScannerOnlyAllocationEnabled": _vm.isScannerOnlyAllocationEnabled
    },
    on: {
      "update-air-count": _vm.getAirShipmentCount,
      "update-airwiz-count": _vm.getWHIZshipmentcount
    }
  }) : _vm._e()], 1) : _c('div', [_c('span', [_vm._v("Allocation Panel is not available for this HUB,Kindly reach out to Tech Support")])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "RVP"
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs('RVP')
      }
    }
  }, [(_vm.IsRVP) ? _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.rvpUserLoading
    },
    on: {
      "update:active": function($event) {
        _vm.rvpUserLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.ActiveTabIndex == 1 && _vm.srList.length > 0) ? _c('Reverse-confirmallocation', {
    attrs: {
      "srList": _vm.srList,
      "hubCODPendingLimit": _vm.hubCODPendingLimit,
      "IsPendingCODBlock": _vm.IsPendingCODBlock,
      "isRSVSr": _vm.isRSVSr,
      "ServiceTypeArrayList": _vm.ServiceTypeArrayList,
      "ServiceTypeList": _vm.ServiceTypeList,
      "EscalationList": _vm.EscalationList,
      "ClusterList": _vm.ClusterList,
      "allocationrefreshflag": _vm.allocationrefreshflag
    }
  }) : _vm._e()], 1) : _c('div', [_c('span', [_vm._v("Allocation Panel is not available for this HUB,Kindly reach out to Tech Support")])])])], 1)], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "All OFP"
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs('OFP')
      }
    }
  }, [(_vm.IsRVP) ? _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.rvpUserLoading
    },
    on: {
      "update:active": function($event) {
        _vm.rvpUserLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.ActiveTabIndex == 1 && _vm.srList.length > 0) ? _c('Reverse-allofp', {
    attrs: {
      "srList": _vm.srList,
      "hubCODPendingLimit": _vm.hubCODPendingLimit,
      "IsPendingCODBlock": _vm.IsPendingCODBlock,
      "isRSVSr": _vm.isRSVSr,
      "ServiceTypeArrayList": _vm.ServiceTypeArrayList,
      "ServiceTypeList": _vm.ServiceTypeList,
      "EscalationList": _vm.EscalationList,
      "ClusterList": _vm.ClusterList,
      "allocationrefreshflag": _vm.allocationrefreshflag
    }
  }) : _vm._e()], 1) : _c('div', [_c('span', [_vm._v("Allocation Panel is not available for this HUB,Kindly reach out to Tech Support")])])])], 1)], 1)])], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mt-2"
  }, [_c('b', [_vm._v("Processing Shipments, please wait..")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51152f7d","hasScoped":true}!./src/views/components/newallocationpagev2/newallocationpagev2.component.html
// module id = 1553
// module chunks = 1